// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  host: 'https://api-econtract.elis.com',
  homeUpdateRate: 30, // seconds
  isMockEnabled: true,
  USERDATA_KEY: 'authf649fc9a5f55',
  appVersion: '1.0.0',
  apiUrl: 'api',
  hereApi: {
    app_id: 'NI3b8d1wppODF4qArQEj',
    app_code: 'NERHnJaPNEjNSc60gI5A',
    jsKey: 'VXSNUkV27BjIS7zE2dC0J11Ii7IaalG44lfTw1G9xoo',
    restKey: '00UK6Qamxu5LliQjk7xSAoQAytBXpimUI0_Gw6oLPnc',
    useHTTPS: true,
  },

  securityConfig: {
    issuer: 'https://elis-employees.okta.com/oauth2/aus4ha0gmn00PrhUK417',
    clientId: '0oa7bh82vnGoKMKjg417',
    scopes: ['openid', 'email', 'profile'],
    pkce: true
  },

  hideNullStops: true,
  proxy: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
